/**
 * Headers de autenticação para as chamadas ao core (getApostatudoApiUrl).
 *
 * Os adapters novos (promocode, roletinha, etc.) chamam o core com
 * fetch cru e, até então, não enviavam o token do usuário — o core não tinha
 * como saber quem estava chamando. A proteção dessas rotas passa a ser o token:
 * o front sempre manda o Bearer do usuário logado e o core decide (401 pra
 * quem não pode). Mesma fonte de token do _cactus_core/ApiService
 * (useAuthStore().accessToken → cookie jwt_token).
 *
 * Só injeta o Authorization quando HÁ token: deslogado chama sem header (igual
 * ao comportamento anterior), então rota pública servida pro anônimo não quebra.
 */
export function getApostatudoAuthHeaders(): Record<string, string> {
  try {
    const { accessToken } = useAuthStore();

    return accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
  } catch {
    // Pinia fora de contexto (ex.: chamada muito cedo no boot) — sem token,
    // segue sem header em vez de derrubar a chamada.
    return {};
  }
}
